import { findTokenAtCursor } from "./macro-token-utils"

export function clampIndex(value, length) {
    if (!Number.isFinite(value)) return 0
    if (value < 0) return 0
    if (value > length) return length
    return value
}

export function isTokenChar(char) {
    return char === "-" || char === "_" || char === ":" || char === "." || isAlphaNumeric(char)
}

export function isAlphaNumeric(char) {
    if (!char) return false
    const code = char.charCodeAt(0)
    return (code >= 48 && code <= 57) || (code >= 65 && code <= 90) || (code >= 97 && code <= 122)
}

export function isClosingDelimiter(text, index) {
    if (!text || text[index] !== "$") return false
    let pos = index - 1
    if (pos < 0 || !isTokenChar(text[pos])) return false
    while (pos >= 0 && isTokenChar(text[pos])) pos--
    return text[pos] === "$"
}

export function isNavigationKey(key) {
    if (!key) return false
    return key === "ArrowDown" || key === "ArrowUp" || key === "Enter" || key === "Escape"
}

export function isSideNavigationKey(key) {
    if (!key) return false
    return key === "ArrowLeft" || key === "ArrowRight"
}

export function buildMacroToken(macro) {
    const id = `${macro?.id ?? ""}`.trim()
    if (!id) return ""
    return `$${id}$`
}

export function resolveCursorIndex(element, cursorOverride, fallback) {
    if (Number.isFinite(cursorOverride)) return cursorOverride
    if (Number.isFinite(element?.selectionStart)) return element.selectionStart
    return fallback
}

export function resolveTokenContextInText(text, cursorIndex) {
    if (!text) return null
    const index = clampIndex(cursorIndex ?? text.length, text.length + 1)
    if (index <= 0 || index > text.length) return null
    let start = index - 1
    while (start >= 0 && isTokenChar(text[start])) start--
    if (text[start] !== "$") return null
    if (text[start - 1] === "$") return null
    if (isClosingDelimiter(text, start)) return null
    if (index !== start + 1 && !isTokenChar(text[start + 1])) return null
    return { start, end: index }
}

export function resolveTokenReplacementRange(text, cursorIndex, context) {
    const match = findTokenAtCursor(text, cursorIndex)
    if (match) return { start: match.start, end: match.end }
    if (context && Number.isFinite(context.start) && Number.isFinite(context.end)) {
        return { start: context.start, end: context.end }
    }
    return null
}

export function replaceRange(value, start, end, nextValue) {
    return `${value.slice(0, start)}${nextValue}${value.slice(end)}`
}

export function withTrailingSpace(token) {
    if (!token) return token
    if (token.endsWith(" ")) return token
    return `${token} `
}
